var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("emc-table-items", {
        attrs: {
          headers: _vm.headers,
          params: _vm.params,
          collections: _vm.collections,
          meta: _vm.meta,
          itemDelete: _vm.itemDelete,
          itemEdit: _vm.model,
          find: false,
          loadingText: _vm.loadingText,
        },
        on: {
          "update:params": function ($event) {
            _vm.params = $event
          },
          "update:collections": function ($event) {
            _vm.collections = $event
          },
          "update:meta": function ($event) {
            _vm.meta = $event
          },
          "update:itemDelete": function ($event) {
            _vm.itemDelete = $event
          },
          "update:item-delete": function ($event) {
            _vm.itemDelete = $event
          },
          "update:itemEdit": function ($event) {
            _vm.model = $event
          },
          "update:item-edit": function ($event) {
            _vm.model = $event
          },
        },
      }),
      _c("sys-faq-register", {
        attrs: { disabledCategory: "", model: _vm.model, show: _vm.showForm },
        on: {
          onCompleted: function ($event) {
            return _vm.getData()
          },
          "update:show": function ($event) {
            _vm.showForm = $event
          },
        },
      }),
      _c("emc-alert-modal", {
        attrs: { text: _vm.textDelete, disabled: _vm.deleting, show: _vm.show },
        on: {
          "update:show": function ($event) {
            _vm.show = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "error",
                      loading: _vm.deleting,
                      disabled: _vm.deleting,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.deleteItem()
                      },
                    },
                  },
                  [
                    _vm._v("Excluir "),
                    _c("v-icon", { attrs: { right: "", dark: "" } }, [
                      _vm._v("mdi-delete"),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_vm.message.length,
          message: _vm.message,
          color: _vm.error ? "error" : "success",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }